import {
  Body3,
  Footer,
  Tag,
  type FooterNavItemProps,
} from '@cointracker/styleguide';
import AppStoreIcon from '@cointracker/styleguide/src/icons/app-store.svg?react';
import PlayStoreIcon from '@cointracker/styleguide/src/icons/play-store.svg?react';
import { REBRAND_URLS } from '@cointracker/ui';
import { useTranslation } from 'react-i18next';

export const FooterLanding = () => {
  const { t } = useTranslation();

  const PLATFORM_TEXT = {
    title: t('footer_landing.platform_text.title'),
    description: t('footer_landing.platform_text.description'),
  };
  const PLATFORM_BUTTONS = [
    {
      href: REBRAND_URLS.APPLE_APP_STORE,
      icon: <AppStoreIcon />,
      label: t('footer_landing.platform_buttons.app_store'),
    },
    {
      href: REBRAND_URLS.GOOGLE_PLAY_STORE,
      icon: <PlayStoreIcon />,
      label: t('footer_landing.platform_buttons.play_store'),
    },
  ];

  const PRIMARY_NAV_ITEMS: Array<FooterNavItemProps> = [
    {
      href: REBRAND_URLS.FEATURES,
      title: t('footer_landing.primary_nav_items.how_it_works'),
    },
    {
      href: REBRAND_URLS.PRICING,
      title: t('footer_landing.primary_nav_items.pricing'),
    },
    {
      href: REBRAND_URLS.FULL_SERVICE,
      title: t('footer_landing.primary_nav_items.full_service'),
    },
    {
      href: REBRAND_URLS.INTEGRATIONS,
      title: t('footer_landing.primary_nav_items.integrations'),
    },
    {
      href: REBRAND_URLS.CALCULATOR,
      title: t('footer_landing.primary_nav_items.profit_calculator'),
    },
    {
      href: REBRAND_URLS.PORTFOLIO_TRACKER,
      title: t('footer_landing.primary_nav_items.portfolio_tracker'),
    },
  ];

  const TERTIARY_NAV_ITEMS: Array<FooterNavItemProps> = [
    {
      href: REBRAND_URLS.ABOUT,
      title: t('footer_landing.tertiary_nav_items.about'),
    },
    {
      href: REBRAND_URLS.BRAND,
      title: t('footer_landing.tertiary_nav_items.brand'),
    },
    {
      href: REBRAND_URLS.CAREERS,

      title: t('footer_landing.tertiary_nav_items.careers'),
      secondaryItem: (
        <Tag secondary caps>
          {t('footer_landing.tertiary_nav_items.hiring')}
        </Tag>
      ),
    },
    {
      href: REBRAND_URLS.TESTIMONIALS,
      title: t('footer_landing.tertiary_nav_items.testimonials'),
    },
  ];

  const SECONDARY_NAV_ITEMS: Array<FooterNavItemProps> = [
    {
      href: REBRAND_URLS.PRICES,
      title: t('footer_landing.secondary_nav_items.prices'),
    },
    {
      href: REBRAND_URLS.WALLET,
      title: t('footer_landing.secondary_nav_items.wallet'),
    },
    {
      href: REBRAND_URLS.BLOG,
      title: t('footer_landing.secondary_nav_items.blog'),
    },
    {
      href: REBRAND_URLS.TAX_GUIDE,
      title: t('footer_landing.secondary_nav_items.tax_guide'),
    },
    {
      href: REBRAND_URLS.GLOSSARY,
      title: t('footer_landing.secondary_nav_items.glossary'),
    },
    {
      href: REBRAND_URLS.SUPPORT,
      title: t('footer_landing.secondary_nav_items.support'),
    },
  ];

  const LOWER_NAV_ITEMS: Array<FooterNavItemProps> = [
    {
      href: REBRAND_URLS.PRIVACY,
      title: t('footer_landing.lower_nav_items.privacy'),
      TypographyComponent: Body3,
    },
    {
      href: REBRAND_URLS.TERMS,
      title: t('footer_landing.lower_nav_items.terms'),
      TypographyComponent: Body3,
    },
    {
      href: REBRAND_URLS.DISCLAIMER,
      title: t('footer_landing.lower_nav_items.disclaimer'),
      TypographyComponent: Body3,
    },
    {
      href: REBRAND_URLS.SECURITY,
      title: t('footer_landing.lower_nav_items.security'),
      TypographyComponent: Body3,
    },
    {
      href: REBRAND_URLS.STATUS,
      title: t('footer_landing.lower_nav_items.status'),
      TypographyComponent: Body3,
    },
  ];
  return (
    <Footer
      platformText={PLATFORM_TEXT}
      platformButtons={PLATFORM_BUTTONS}
      primaryNavItems={PRIMARY_NAV_ITEMS}
      secondaryNavItems={SECONDARY_NAV_ITEMS}
      tertiaryNavItems={TERTIARY_NAV_ITEMS}
      lowerNavItems={LOWER_NAV_ITEMS}
    />
  );
};
